import api from './api';

const getAgendamentos = async () => {
  const { data } = await api.get('/agendamentos');
  return data;
};

const agendamentoService = { getAgendamentos };
export default agendamentoService;